// Fallback words for when AI title generation fails
const chatTitleWords = [
  // Adjectives
  "Creative",
  "Smart",
  "Quick",
  "Fresh",
  "New",
  "Clear",
  "Modern",
  "Focused",

  // Nouns
  "Discussion",
  "Chat",
  "Session",
  "Talk",
  "Idea",
  "Solution",
  "Project",
  "Plan",
];

/**
 * Generates a simple fallback title when AI generation fails
 */
function generateSimpleTitle(): string {
  const adjectives = chatTitleWords.slice(0, 8);
  const nouns = chatTitleWords.slice(8);

  const randomAdjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const randomNoun = nouns[Math.floor(Math.random() * nouns.length)];

  return `${randomAdjective} ${randomNoun}`;
}

/**
 * Generates a contextual chat title using AI based on the first message
 * Falls back to simple title generation if AI fails
 */
export async function generateChatTitle(message: string): Promise<string> {
  try {
    const response = await fetch("/api/generate-title", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ message }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (data.title && typeof data.title === "string" && data.title.trim()) {
      return data.title.trim();
    }

    throw new Error("Invalid title response");
  } catch (error) {
    console.warn("Failed to generate AI title, using fallback:", error);
    return generateSimpleTitle();
  }
}

